<template>
    <div>
        <div class="share-wrap" v-if="list.length > 0">
			<div class="share-item " v-for="(iten, idx) in list" :key="idx" @click="goShare(iten)">
				<img class="facebook" :src="iten.cover_url" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
			list: []
        }
    },
    created() {
		this.getPic()
        // console.log(this.$route, window.location.href)
    },
    methods: {

		goShare(v) {
                window.open(v.url,'_blank')
		},
		getPic() {
			this.$api.commonGeturl({}).then(res => {
				if(res.status) {
					this.list = res.data
				}
			})
		},
        shareAction() {
            // $.fn.shareThis=function(type, title, url){
	var image       =   
        back_url    =
        url         =
        encode_url  =
        title       =   "";

    title   = 'Sanlida Archery';
    url     =   window.location.href;
	e_url   =   encodeURIComponent(url);
	title   =   encodeURIComponent(title);
    // if(url==undefined){
	// 	url=window.location.href;
	// }
	// if(url.indexOf("#")>0){
	// 	url=url.substring(0, url.indexOf("#"));
	// }

	// if(type=="pinterest"){
	// 	image=$(".big_box .big_pic>img").attr("src");
	// 	if(image.indexOf('ueeshop.ly200-cdn.com')!=-1){
	// 		image=$(".big_box .big_pic>img").attr("src");
	// 	}else{
	// 		image=window.location.protocol+'//'+window.location.host+$(".big_box .big_pic>img").attr("src");
	// 	}
	// }
	// if(image!="" && image!=undefined){
	// 	image=encodeURIComponent(image);
	// }
	switch(type){
		case "delicious":
			back_url = "https://delicious.com/post?title=" + title + "&url=" + e_url;
			break;
		case "digg":
			back_url = "http://digg.com/submit?phase=2&url=" + e_url + "&title=" + title + "&bodytext=&topic=tech_deals";
			break;
		case "reddit":
			back_url = "http://reddit.com/submit?url=" + e_url + "&title=" + title;
			break;
		case "furl":
			back_url = "http://www.furl.net/savedialog.jsp?t=" + title + "&u=" + e_url;
			break;
		case "rawsugar":
			back_url = "http://www.rawsugar.com/home/extensiontagit/?turl=" + e_url + "&tttl=" + title;
			break;
		case "stumbleupon":
			back_url = "http://www.stumbleupon.com/submit?url=" + e_url + "&title=" + title;
			break;
		case "blogmarks":
			break;
		case "facebook":
			back_url = "http://www.facebook.com/share.php?src=bm&v=4&u=" + e_url + "&t=" + title;
			break;
		case "technorati":
			back_url = "http://technorati.com/faves?sub=favthis&add=" + e_url;
			break;
		case "spurl":
			back_url = "http://www.spurl.net/spurl.php?v=3&title=" + title + "&url=" + e_url;
			break;
		case "simpy":
			back_url = "http://www.simpy.com/simpy/LinkAdd.do?title=" + title + "&href=" + e_url;
			break;
		case "ask":
			break;
		case "google":
			back_url = "http://www.google.com/bookmarks/mark?op=edit&output=popup&bkmk=" + e_url + "&title=" + title;
			break;
		case "netscape":
			back_url = "http://www.netscape.com/submit/?U=" + e_url + "&T=" + title + "&C=";
			break;
		case "slashdot":
			back_url = "http://slashdot.org/bookmark.pl?url=" + url + "&title=" + title;
			break;
		case "backflip":
			back_url = "http://www.backflip.com/add_page_pop.ihtml?title=" + title + "&url=" + e_url;
			break;
		case "bluedot":
			back_url = "http://bluedot.us/Authoring.aspx?u=" + e_url + "&t=" + title;
			break;
		case "kaboodle":
			back_url = "http://www.kaboodle.com/za/selectpage?p_pop=false&pa=url&u=" + e_url;
			break;
		case "squidoo":
			back_url = "http://www.squidoo.com/lensmaster/bookmark?" + e_url;
			break;
		case "twitter":
			back_url = "https://twitter.com/intent/tweet?status=" + title + ":+" + e_url;
			break;
		case "pinterest":
			back_url = "http://pinterest.com/pin/create/button/?url=" + e_url + "&media=" + image + "&description=" + title;
			break;
		case "vk":
			back_url = "http://vk.com/share.php?url=" + url;
			break;
		case "bluedot":
			back_url = "http://blinkbits.com/bookmarklets/save.php?v=1&source_url=" + e_url + "&title=" + title;
			break;
		case "blinkList":
			back_url = "http://blinkbits.com/bookmarklets/save.php?v=1&source_url=" + e_url + "&title=" + title;
			break;
		case "linkedin":
			back_url = "http://www.linkedin.com/cws/share?url=" + e_url + "&title=" + title;
			break;
		case "googleplus":
			back_url = "https://plus.google.com/share?url=" + e_url;
			break;
	}
	    window.open(back_url, "bookmarkWindow");
// }
        }
    }
}
</script>

<style lang="scss" scoped>

.share-item{
    width: 40px;
    height: 40px;
    display: inline-block;
    vertical-align: top;
    position: relative;
    cursor: pointer;
    &:hover{
        .pop{
            display: block;
        }
    }
    .pop{
        display: none;
        position: absolute;
        top: 40px;
        left: -14px;
        background: #fff;
        border: 1px solid #f5f5f5;
        box-shadow: 0 0 5px rgb(0 0 0 / 10%);
        padding: 14px;
        border-radius: 5px;
        z-index: 999;
        .pop-child{
            display: flex;
            align-items: center;
            .facebook{
                position: initial;
                left: initial;
                top: initial;
                transform: initial;
            }
            i {
                width: 100px;
            }
        }
    }
    .facebook {
        position: absolute;
        width: inherit;
        width: 40px;
        background-position: -16px 0;
        height: 40px;
        display: block;
        line-height: 40px;
        white-space: nowrap;
        text-indent: 999px;
        overflow: hidden;
        background-image: url('~@/assets/images/coupon.png');
        background-repeat: no-repeat;
        transition: all .2s ease-in-out;
        -webkit-transition: all .2s ease-in-out;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}
    
</style>